// Importaciones de React y otros componentes.
import React from 'react';
import backgroundVideo from '../videos/banner-dosssee.mp4'; // Video de fondo para el banner.
import Carousel from './Carousel'; // Componente de carrusel de imágenes/tarjetas.
import './styles.css'; // Archivo de estilos que probablemente contiene las animaciones.

/**
 * Componente Banner.
 * Muestra un banner a pantalla completa con un video de fondo.
 * Contiene un título y una lista de enfoques a la izquierda, y un carrusel a la derecha (visible en pantallas grandes).
 */
const Banner = () => {
  return (
    // Contenedor principal que ocupa toda la pantalla (h-screen) y es un flex container.
    <div className="flex w-full h-screen relative">
      
      {/* Elemento de video para el fondo. */}
      <video 
        autoPlay // El video se reproduce automáticamente.
        muted // El video no tiene sonido.
        playsInline // Necesario para la reproducción automática en algunos navegadores móviles.
        className="w-full h-full object-cover absolute top-0 left-0 z-0" // Estilos para que cubra todo el fondo.
      >
        <source src={backgroundVideo} type="video/mp4" />
        Tu navegador no soporta la etiqueta de video.
      </video>
      
      {/* Contenedor para el texto, posicionado sobre el video (z-10). */}
      <div className="flex flex-col justify-center items-center p-10 lg:p-20 space-y-6 text-white w-full lg:w-1/2 relative z-10">
        {/* Título principal con una clase de animación. */}
        <h1 className="animacionh text-4xl lg:text-5xl font-bold shadow-md text-center">NUESTRO ENFOQUE</h1>
        
        {/* Lista de enfoques, cada elemento con una clase de animación. */}
        <ul>
          <li className="text-xl font-bold lg:text-4xl shadow-sm text-center animacionl">
            Ciberseguridad
          </li>
          <li className="text-xl font-bold lg:text-4xl shadow-sm text-center animacionl">
            Inteligencia Artificial
          </li>
          <li className="text-xl font-bold lg:text-4xl shadow-sm text-center animacionl">
            Consultoría Tecnológica
          </li>
          {/* Elemento de lista vacío, posiblemente para espaciado o un futuro item. */}
          <li className="text-xl font-bold lg:text-4xl shadow-sm text-center animacionl">
          </li>
        </ul>
      </div>
      
      {/* Contenedor para el carrusel. Oculto en pantallas pequeñas (hidden), visible en grandes (lg:flex). */}
      <div className="hidden lg:flex w-1/2 h-full items-center justify-center p-5 mx-8">
        <Carousel />
      </div>
    </div>
  );
};

// Exporta el componente para su uso en otras páginas, como Home.js.
export default Banner;
